import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "companies roba-container flex flex-align-start" }
const _hoisted_2 = { class: "companies__filters white pa-2 mr-2" }
const _hoisted_3 = { class: "mb-05" }
const _hoisted_4 = ["checked", "onChange"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "flex flex-align-center mb-2" }
const _hoisted_8 = { class: "companies__search-bar white pa-2 flex-grow-1" }
const _hoisted_9 = { class: "companies__search" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 1,
  class: "companies__search-icon"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "companies__pagination mt-2"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  class: "companies-transition-content",
  key: "content"
}
const _hoisted_18 = {
  class: "loading mt-2",
  key: "loader"
}
const _hoisted_19 = {
  class: "mt-2",
  key: "companies"
}
const _hoisted_20 = {
  key: 1,
  class: "no-results"
}
const _hoisted_21 = {
  key: 2,
  class: "companies__sheet-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_row = _resolveComponent("company-row")!
  const _component_crud_company = _resolveComponent("crud-company")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('COMMON.FILTERS')), 1),
      _cache[8] || (_cache[8] = _createElementVNode("hr", { class: "mt mb" }, null, -1)),
      _createElementVNode("b", null, _toDisplayString(_ctx.$t('COMMON.STATUS_PORTAL_FILTER_TITLE')), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portalStatuses, (status) => {
        return (_openBlock(), _createElementBlock("label", {
          class: "companies__checkbox mt",
          key: status.key
        }, [
          _createElementVNode("input", {
            type: "checkbox",
            checked: _ctx.statusFilter.includes(status.value),
            onChange: ($event: any) => (_ctx.toggleStatusFilter(status.value, $event))
          }, null, 40, _hoisted_4),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "companies__checkbox-box" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`ENUM.PORTAL_STATUS.${status.key}`)), 1)
        ]))
      }), 128)),
      _createElementVNode("button", {
        class: "clear-button mt",
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearStatusFilter && _ctx.clearStatusFilter(...args))),
        disabled: _ctx.statusFilter.length === 0
      }, _toDisplayString(_ctx.$t('COMMON.CLEAR_FILTERS')), 9, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              class: "companies__search-input",
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
              placeholder: _ctx.$t("COMPANIES.SEARCH_PLACEHOLDER")
            }, null, 8, _hoisted_10), [
              [_vModelText, _ctx.searchQuery]
            ]),
            (_ctx.searchQuery)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "companies__search-clear",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchQuery = ""))
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "icons8-delete" }, null, -1)
                ]))]))
              : _createCommentVNode("", true),
            (!_ctx.searchQuery)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "icons8-search" }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.hasAnyPermission([_ctx.permissions.CompaniesCreate, _ctx.permissions.CompanyCreateAny]))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "companies__create-button ml-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showCrudCompany = true)),
              disabled: (_ctx.impersonated && !_ctx.impersonatedWithOriginalRights),
              type: "button"
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("i", { class: "icons8-city-buildings mr-05" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t('COMPANIES.CREATE_COMPANY')), 1)
            ], 8, _hoisted_12))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showPagination)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToPreviousPage && _ctx.goToPreviousPage(...args))),
              disabled: _ctx.currentPage <= 1
            }, "Prev", 8, _hoisted_14),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePageTokens, (token, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: `page-${index}-${token}`,
                type: "button",
                disabled: token === "...",
                class: _normalizeClass({ "is-active": token === _ctx.currentPage, "is-ellipsis": token === "..." }),
                onClick: ($event: any) => (_ctx.goToPage(token))
              }, _toDisplayString(token), 11, _hoisted_15))
            }), 128)),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToNextPage && _ctx.goToNextPage(...args))),
              disabled: _ctx.currentPage >= _ctx.totalPages
            }, "Next", 8, _hoisted_16)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_17, [
            (_ctx.loading && !_ctx.showCrudCompany)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageSize, (n) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "companies__skeleton mt",
                      key: n
                    }))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entities, (company) => {
                    return (_openBlock(), _createBlock(_component_company_row, {
                      class: "mt",
                      company: company,
                      key: company.id,
                      onEditCompany: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showCompanyCrud($event)))
                    }, null, 8, ["company"]))
                  }), 128))
                ]))
          ])
        ]),
        _: 1
      }),
      (_ctx.showNoResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('COMPANY.ADD_COMPANY.NO_DATA')), 1))
        : _createCommentVNode("", true),
      (_ctx.showCrudCompany)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", {
              class: _normalizeClass(["companies__sheet", {"red-border" : _ctx.action === _ctx.userActions.Inactivate || _ctx.action === _ctx.userActions.Delete }])
            }, [
              (_ctx.showCrudCompany)
                ? (_openBlock(), _createBlock(_component_crud_company, {
                    key: 0,
                    onHide: _ctx.close,
                    "edit-company": _ctx.company,
                    action: _ctx.action
                  }, null, 8, ["onHide", "edit-company", "action"]))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}